import React, { useState } from "react";

// import { Link } from "react-router-dom";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import driveways1 from "../../../images/categories/driveways/PPI-driveway-001.jpg";
import driveways2 from "../../../images/categories/driveways/PPI-driveway-002.jpg";
import driveways3 from "../../../images/categories/driveways/PPI-driveway-003.jpg";
import driveways4 from "../../../images/categories/driveways/PPI-driveway-004.jpg";
import driveways5 from "../../../images/categories/driveways/PPI-driveway-005.jpg";
import driveways6 from "../../../images/categories/driveways/PPI-driveway-006.jpg";
import driveways7 from "../../../images/categories/driveways/PPI-driveway-007.jpg";
import driveways8 from "../../../images/categories/driveways/PPI-driveway-008.jpg";
import driveways9 from "../../../images/categories/driveways/PPI-driveway-009.jpg";
import driveways10 from "../../../images/categories/driveways/PPI-driveway-010.jpg";
import driveways11 from "../../../images/categories/driveways/PPI-driveway-011.jpg";
import driveways12 from "../../../images/categories/driveways/PPI-driveway-012.jpg";
import driveways13 from "../../../images/categories/driveways/PPI-driveway-013.jpg";
import driveways14 from "../../../images/categories/driveways/PPI-driveway-014.jpg";
import driveways15 from "../../../images/categories/driveways/PPI-driveway-015.jpg";
import driveways16 from "../../../images/categories/driveways/PPI-driveway-016.jpg";
import driveways17 from "../../../images/categories/driveways/PPI-driveway-017.jpg";
import driveways18 from "../../../images/categories/driveways/PPI-driveway-018.jpg";
import driveways19 from "../../../images/categories/driveways/PPI-driveway-019.jpg";
import driveways20 from "../../../images/categories/driveways/PPI-driveway-020.jpg";

//Utils
import { mapGallery } from "../../../../../Utils/Utils";

// SEO
import SEO from "../../../../../SEO/index.js";
import StructuredData from "../../../../../SEO/structuredData";

const Driveways = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: driveways1,
      description:
        "Two car garage with paving stone driveway and connecting walkway. A line of darker stones segments the driveway and leads to the walkway for an added touch.",
      aria: "Two Story Home With a Two car garage with paving stone driveway and connecting walkway",
    },
    {
      image: driveways2,
      description:
        " Paving stone driveway with hedges in a gray colorway at a home in Burbank, CA.",
      aria: "Paving stone driveway with hedges in a gray colorway at a home in Burbank, CA",
    },
    {
      image: driveways3,
      description:
        "Expansive paving stone driveway and pathway leading to multiple structures. The homeowners chose a sandy brown colorway to tie in with the color scheme of their home.",
      aria: "Sandy brown paving stone driveway and pathway leading to home and garage",
    },
    {
      image: driveways4,
      description:
        "Understates paving stone driveway in a charcoal gray colorway.",
      aria: "Charcoal gray paving stone driveway leading to home",
    },
    {
      image: driveways5,
      description:
        "Large terracotta colored paving stone driveway with a statement water feature and paver walkway steps leading to the front door.",
      aria: "Terracotta colored paving stone driveway with a statement water feature and paver walkway steps",
    },
    {
      image: driveways6,
      description:
        "Paver driveway and garden pathway leading to the front entrance on this Los Angeles home.",
      aria: "Paver driveway and garden pathway leading to the front entrance of a Los Angeles home",
    },
    {
      image: driveways7,
      description: "Multi colored paving stone driveway with paver edging.",
      aria: "Multi colored paving stone driveway with paver edging",
    },
    {
      image: driveways8,
      description:
        "Long paving stone driveway extending to the backyard with tumbled stone edging. This design also includes a raised paving stone front walkway and small deck.",
      aria: "Paving stone driveway extending to the backyard with tumbled stone edging",
    },
    {
      image: driveways9,
      description:
        "Warm colored paving stone driveway and walkway with intricate circular pattern inlaid into the design. We added some drama to this driveway build to break up the rigidity of a normal driveway.",
      aria: "Warm colored paving stone driveway & walkway with intricate circular pattern inlaid into the design",
    },
    {
      image: driveways10,
      description:
        "Curved paver driveway installed over a sloping yard. We created a long driveway across varying elevations to connect this home to the street below.",
      aria: "Curved paver driveway installed over a sloping yard leading to a home",
    },
    {
      image: driveways11,
      description:
        "Large driveway construction in Calabasas, CA with built-in draining and water feature.",
      aria: "Large driveway construction in Calabasas, CA with built-in draining and water feature",
    },
    {
      image: driveways12,
      description:
        "La Canada driveway constructed out of light brown paving stones and connects the street to the backyard garage.",
      aria: "La Canada driveway constructed out of light brown paving stones",
    },
    {
      image: driveways13,
      description:
        "Gray paving stone residential driveway with a circular pattern in colored pavers.",
      aria: "Gray paving stone residential driveway with a circular pattern in colored pavers",
    },
    {
      image: driveways14,
      description:
        "Large driveway with inlaid circular pattern that wraps around the property and extends into the backyard.",
      aria: "Driveway with inlaid circular pattern that wraps around the property and extends into the backyard",
    },
    {
      image: driveways15,
      description:
        "Sloped driveway made from paving stones that leads from the driveway to the front walkway. This driveway was installed in the rainbow shape to create two entrances for easy maneuverability.",
      aria: "Sloped driveway made from paving stones that leads from the driveway to the front walkway",
    },
    {
      image: driveways16,
      description: "Traditional paving stone driveway for a ranch-style home.",
      aria: "Traditional paving stone driveway for a ranch-style home",
    },
    {
      image: driveways17,
      description:
        "A multicolored paving stone driveway was installed for this Los Angeles home that will last decades.",
      aria: "A multicolored paving stone driveway in front of  Los Angeles home",
    },
    {
      image: driveways18,
      description:
        "Brick colored paving stone driveway. This home in Encino, CA had brick accents throughout which was taken into consider when choosing the driveway paving stone colors.",
      aria: "Brick colored paving stone driveway in Encino, CA",
    },
    {
      image: driveways19,
      description:
        "Pavingstone driveway and walkway laid in a herringbone pattern.",
      aria: "Pavingstone driveway and walkway laid in a herringbone pattern",
    },
    {
      image: driveways20,
      description:
        "Ranch style home with sloped paving stone driveway and narrow walkway leading to the front steps.",
      aria: "Ranch style home with sloped paving stone driveway and narrow walkway leading to the front steps",
    },
  ];

  return (
    <>
      <SEO
        title="Paver Driveway Ideas | Southern California | Pacific Pavingstone"
        description="View the beautiful paver driveway projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={"https://www.pacificpavingstone.com/gallery/driveways"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Paver Driveway Gallery",
          description:
            "View the beautiful paver driveway projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/driveways-banner.14cc00a7.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        {/* <div className="row justify-content-center hero-unit">
          <div className="col-12 no-side-padding">
            <div className="title">
              <Link to="/gallery">Back to Gallery</Link>
              <h1>Carpentry Gallery</h1>
            </div>
          </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "carpentry", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default Driveways;
